<div class="ui-assignment-selector">
  <ui-select
    [label]="label()"
    [required]="required()"
    [multiple]="!single()"
    [value]="values()[0] || ''"
    [values]="values()"
    [options]="options()"
    [error]="error()"
    [hint]="hint()"
    [loadMoreOnScroll]="loadMoreOnScroll()"
    [loadingMoreOptions]="loadingMoreOptions()"
    [hasMoreOptions]="hasMoreOptions()"
    (valueChange)="onValueChange($event)"
    (valuesChange)="onValuesChange($event)"
    (loadMoreOptions)="onLoadMoreOptions()"
  ></ui-select>


  @if (selectedRows().length=== 0) {
    <ui-empty-state
          [title]="emptyStateTitle() | uiLabelTranslate"
          [description]="emptyStateDescription() | uiLabelTranslate"
        ></ui-empty-state>
  }
  @else {

  @if (badgeRules(); as resolvedBadgeRules) {
    <ui-table
      [columns]="columns()"
      [data]="selectedRows()"
      [emptyMessage]="emptyMessage()"
      [showToolbar]="false"
      [showPagination]="showPagination()"
      [defaultPageSize]="defaultPageSize()"
      [showActionsColumn]="rowActions().length > 0"
      [rowActions]="rowActions()"
      [badgeRules]="resolvedBadgeRules"
      (actionClick)="onActionClick($event)"
    ></ui-table>
  } @else {
    <ui-table
      [columns]="columns()"
      [data]="selectedRows()"
      [emptyMessage]="emptyMessage()"
      [showToolbar]="false"
      [showPagination]="showPagination()"
      [defaultPageSize]="defaultPageSize()"
      [showActionsColumn]="rowActions().length > 0"
      [rowActions]="rowActions()"
      (actionClick)="onActionClick($event)"
    ></ui-table>
  }
}
</div>
